import { grids } from '../../styles'

/**
 * Works out a CSS calc() width using flexible columns + fixed px gutters
 * @param { Number } cols - number of columns to span
 * @param { String } grid - grid configuration to use
 * @param { Number } totalCols - the total column count of the grid
 */

export default function columns({
  cols,
  grid = 'narrow',
  totalCols = 12,
}) {
  const { gutter, margin, breakpoint } = grids[grid]

  // On mobile, use simpler calculation that preserves content space
  if (typeof window !== 'undefined' && window.innerWidth <= 767) {
    return `calc(100% - ${margin * 2}px)`
  }

  // px value occupied by columns
  const totalColWidth = breakpoint - (totalCols * (gutter - 1)) - (margin * 2)
  const singleColWidth = totalColWidth / totalCols // px value of 1 column
  const singleColWidthPercent = (singleColWidth / breakpoint) * 100 // 1 column as % of container
  const colWidth = singleColWidthPercent * cols // total column width, without gutters
  return `calc(${colWidth}vw + ${(cols - 1) * gutter}px)` // column width as vw + gutters
}
